export interface MapsLinkProps {
  lat: string;
  lng: string;
  zoom?: number;
  label?: string;
}

export default function MapsLink(props: MapsLinkProps) {
  const { lat, lng, zoom = 5, label } = props;

  const link = `http://maps.google.com/maps?z=${zoom}&t=m&q=loc:${lat}+${lng}`;

  return (
    <a target="_blank" rel="noopener" href={link}>
      {label || link}
    </a>
  );
}
